// extracted by mini-css-extract-plugin
module.exports = {"root":"Timestamp-root-3jLQ1","text":"Timestamp-text-1llWJ typography-timestamp-2gyl1"};